<template lang="pug">
.cp-product3
  .page1
    .wrap.procuct-header
      .left-wrap
        p 科应™来电卫士
        p 一款轻灵小巧的随身助手，帮您接待来话，亲切沟通，依据来电目的自动分类，抵御骚扰电话，留存重要电话有效信息
    product-list2(:config="productListConfig")
  content-list(:list="list2")
  apply-list(:info="applyInfo", :img="applyImg", @showModal="showModal")
  page-belt(:beltType="1", @showModal="showModal")
</template>
<script>
import productList2 from './components/product-list2'
import contentList from './components/content-list'
import applyList from './components/apply-list'

export default {
  components: {
    productList2,
    contentList,
    applyList,
  },
  props: {},
  data () {
    return {
      productListConfig: {
        img: 'weidu3.png',
        list: [
          { iconClass: 'iconzhinengduihua', label: '智能对话', content: '全新“云魁”语义引擎助力科应灵活应对各类话务，与来客亲切智能沟通' },
          { iconClass: 'iconfunengqiyeyingyong', label: '防漏接', content: '开启时，收揽一切话务，任意电话不漏接' },
          { iconClass: 'iconfangsaorao', label: '防骚扰', content: '有效判断来电语义真实目的，深度学习多种特征，99%准确率识别骚扰电话' },
          { iconClass: 'iconbianjiejieru', label: '信息留存', content: '重要电话微信提醒，通话过程语义转写，来电信息一目了然' },
        ]
      },
      list2: [
        { title: '设置转接', content: '两步轻松设置转接，多样真人语音包自由选择，征召AI助手助您一臂之力', labels: ['使用便捷', '真人语音', '简单实用'], imgSrc: require('@/assets/set-transfer.png'), imgStyle: 'width: 455px; margin-right: 140px' },
        { title: 'AI交互', content: 'AI助手自动接听，与来话客人亲切沟通，了解客人意图，记录完整通话内容', labels: ['智慧应答', '情感分析', '实时记录'], imgSrc: require('@/assets/ai-interactive.png'), imgStyle: 'width: 455px' },
        { title: '客户分类', content: '科应根据客人语义，深度学习多种话务特征，判断用户意图，分类骚扰与重要话务', labels: ['意图判断', '话务分类', '辨别骚扰'], imgSrc: require('@/assets/customer-group.png'), imgStyle: 'width: 447px; margin-right: 196px' },
        { title: '通知提醒', content: '重要话务通知并提供完整的通过过程语义转写，电话不漏接的同时，做到重要通话结果一目了然，方便商务人士随时处理', labels: ['即刻通知', '语义转写', '通话报告'], imgSrc: require('@/assets/msg-notice.png'), imgStyle: 'width: 448px' },
      ],
      applyInfo: {
        titles: ['骚扰拦截', '智能接待'],
        content: '生活中我们总是受到垃圾电话的骚扰，又害怕丢失重要电话，科应来电卫士能帮您智能接待，并判断来电意向，清晰分类来话人员。做到骚扰电话全拦截，重要电话不丢失，通话信息有留存。'
      },
      applyImg: { src: require('../../assets/apply3.png'), style: 'width: 488px' },
    }
  },
  computed: {},
  methods: {
    showModal () {
      this.$emit('showModal', true)
    }
  }
}
</script>
<style lang="stylus">
@import './config'
.cp-product3
  .page1
    padding-top $topbar-height
    background #0a1e50
    .procuct-header
      height 580px
      background: url("../../assets/product3.jpg") center no-repeat
      background-size: cover;
      margin-bottom -121px
      margin-top -94px
    .wrap
      position relative
      .left-wrap
        position absolute
        padding-top 178px
        left 20%
        width 389px
        p
          &:first-child
            font-size 36px
            margin-bottom 15px
          &:nth-child(2)
            font-size 16px
            color #D5DCEC
        .banner-btn
          margin-top 38px
    .banner-wrap
      position relative
</style>
